/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    export class MeevoNotificationTag implements angular.IDirective {
        restrict = "E";
        scope = {
            contentKey: "@",
            disabled: "=ngDisabled",
            notificationType: "=",
            commTypeUser: "=",
            isSingleLocation: "=?",
            callbackFunction: "=?",
            context: "=?"
        };

        templateUrl = "app/components/controls/notificationTagTemplate.html";

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            var input = element.find('input');

            scope.appEnums = Meevo.Model.AppAreaEnum;
            scope.communicationType = Meevo.Model.CommunicationTypeEnum;
            scope.communicationTypeUser = Meevo.Model.CommunicationTypeUserEnum;

            //the display test and the angular expresion will be generated from file or DB

            //Generic Tags
            scope.genericEmailUnSubsText = 'Email Unsubscribe';
            scope.genericEmailUnSubsValue = "<a href='{UnsubscribeUrl}'>Unsubscribe</a>";
            scope.genericObShortUrlText = 'Online Booking URL';
            scope.genericObShortUrlValue = '{OBShortUrl}';
            scope.genericShortDateText = 'Today Short Date';
            scope.genericShortDateValue = '{TodayDateShort}';
            scope.genericLongDateText = 'Today Long Date';
            scope.genericLongDateValue = '{TodayDateLong}';

            scope.genericEmailUnSubs = scope.genericEmailUnSubsText;
            scope.genericObShortUrl = scope.genericObShortUrlText;
            scope.genericShortDate = scope.genericShortDateText;
            scope.genericLongDate = scope.genericLongDateText;


            //Business Information
            scope.busNameText = 'Name';
            scope.busNameValue = '{BusinessInfo.Name}';
            scope.busPhoneText = 'Phone';
            scope.busPhoneValue = '{BusinessInfo.PhoneNumber}';
            scope.busFullAddressText = 'Full Address';
            scope.busFullAddressValue = '{BusinessInfo.FullAddress}';
            scope.busAddress1Text = 'Address 1';
            scope.busAddress1Value = '{BusinessInfo.Address.Address1}';
            scope.busAddress2Text = 'Address 2';
            scope.busAddress2Value = '{BusinessInfo.Address.Address2}';
            scope.busCityText = 'City';
            scope.busCityValue = '{BusinessInfo.Address.City}';
            scope.busStateText = 'State';
            scope.busStateValue = '{BusinessInfo.Address.State}';
            scope.busZipCodeText = 'Zip Code';
            scope.busZipCodeValue = '{BusinessInfo.Address.ZipCode}';

            scope.busEmailAddressText = 'Email Address';
            scope.busEmailAddressValue = '{BusinessInfo.EmailAddress}';

            scope.busBusinessTypeNameText = 'Business Type';
            scope.busBusinessTypeNameValue = '{BusinessInfo.BusinessTypeName}';

            scope.busBusinessWebsiteURLText = 'Website (Email)';
            scope.busBusinessWebsiteURLValue = "<a href='{BusinessInfo.WebAddressUrl}'>Click here</a>";

            scope.busBusinessWebsiteURLSMSText = 'Website (Text Message)';
            scope.busBusinessWebsiteURLSMSValue = "{BusinessInfo.WebAddressUrl}";

            scope.busName = scope.busNameText;
            scope.busPhone = scope.busPhoneText;
            scope.busFullAddress = scope.busFullAddressText;
            scope.busAddress1 = scope.busAddress1Text;
            scope.busAddress2 = scope.busAddress2Text;

            scope.busCity = scope.busCityText;
            scope.busState = scope.busStateText;
            scope.busZipCode = scope.busZipCodeText;
            scope.busEmailAddress = scope.busEmailAddressText;

            scope.busBusinessTypeName = scope.busBusinessTypeNameText;
            scope.busBusinessWebsiteURL = scope.busBusinessWebsiteURLText;
            scope.busBusinessWebsiteURLSMS = scope.busBusinessWebsiteURLSMSText;

            // 5 star rating
            scope.starRatingUrlText = 'Rating Url';
            scope.starRatingUrlValue = '{RatingUrl}';
            scope.starRatingShortUrlText = 'Rating Short Url';
            scope.starRatingShortUrlValue = '{RatingShortUrl}';

            scope.starRatingUrl = scope.starRatingUrlText;
            scope.starRatingShortUrl = scope.starRatingShortUrlText;

            //Client Information
            scope.clientFirstNameText = 'First Name';
            scope.clientFirstNameValue = '{Client.FirstName}';
            scope.clientFirstLastNameText = 'First Name & Last Name';
            scope.clientFirstLastNameValue = '{Client.FirstName} {Client.LastName}';
            scope.clientServiceDueText = 'Service Due';
            scope.clientServiceDueValue = '{ServiceDue}';
            scope.clientPhoneText = 'Primary Phone';
            scope.clientPhoneValue = '{Client.PrimaryPhone}';
            scope.clientIntakeFormUrlEmailText = 'Client Intake Form URL (Email)';
            scope.clientIntakeFormUrlEmailValue = "<a href='{ClientIntakeFormUrl}'>Click here to fill out the forms</a>";
            scope.clientIntakeFormUrlSMSText = 'Client Intake Form URL (SMS)'
            scope.clientIntakeFormUrlSMSValue = '{ClientIntakeFormUrl}'
            scope.productVariantsDisplayNameText = 'Product due for purchase'
            scope.productVariantsDisplayNameValue = '{Band(ProductVariants)}{ProductVariantDisplayName}<br>{EndBand}'
            scope.referredClientsDisplayNameText = 'Clients referred since last email'
            scope.referredClientsDisplayNameValue = '{Band(ReferredClients)}{ReferredClientDisplayName}<br>{EndBand}'

            scope.clientFirstName = scope.clientFirstNameText;
            scope.clientFirstLastName = scope.clientFirstLastNameText;
            scope.clientPhone = scope.clientPhoneText;
            scope.clientServiceDue = scope.clientServiceDueText;
            scope.clientIntakeFormUrlEmail = scope.clientIntakeFormUrlEmailText;
            scope.clientIntakeFormUrlSMS = scope.clientIntakeFormUrlSMSText;
            scope.productVariantsDisplayName = scope.productVariantsDisplayNameText;
            scope.referredClientsDisplayName = scope.referredClientsDisplayNameText;

            //Employee Information
            scope.empFirstNameText = 'First Name';
            scope.empFirstNameValue = '{Employee.FirstName}';
            scope.empLastNameText = 'Last Name';
            scope.empLastNameValue = '{Employee.LastName}';

            scope.empCodeText = 'Employee Code';
            scope.empCodeValue = '{Employee.EmployeeCode}';

            scope.empNicknameText = 'Nickname';
            scope.empNicknameValue = '{Employee.NickName}';


            scope.empImageText = 'Employee Image';
            scope.empImageValue = '<img src="{Employee.ThumbUri}" />';

            //default display text
            scope.empFirstName = scope.empFirstNameText;
            scope.empLastName = scope.empLastNameText;
            scope.empCode = scope.empCodeText;
            scope.empNickname = scope.empNicknameText;
            scope.empImage = scope.empImageText;

            //appointment
            scope.currentAptNoteText = 'Notes';
            scope.currentAptNoteValue = '{Appointment.Note}';
            scope.currentAptShortDateText = 'Short Date';
            scope.currentAptShortDateValue = '{Appointment.AppointmentDateShort}';
            scope.currentAptLongDateText = 'Long Date';
            scope.currentAptLongDateValue = '{Appointment.AppointmentDateLong}';

            scope.currentAptStartTimeText = 'Start Time';
            scope.currentAptStartTimeValue = '{Appointment.AppointmentTime}';

            scope.currentAptCancellationReasonText = 'Cancellation Reason';
            scope.currentAptCancellationReasonValue = '{Appointment.CancellationReasonDisplayName}';

            scope.currentAptFirstServiceDisplayNameText = '1st Service Display Name';
            scope.currentAptFirstServiceDisplayNameValue = '{Appointment.FirstServiceName}';

            scope.currentAptAllServiceDisplayNameText = 'All Service(s) Display Name';
            scope.currentAptAllServiceDisplayNameValue = '{Band(Appointment.Services)}{ServiceDisplayName}{EndBand}';

            scope.currentAptAllServicesWithEmpNameText = 'All Service(s) with Employee name & thumbnail';
            scope.currentAptAllServicesWithEmpNameValue = "{Band(Appointment.Services)}{ServiceDisplayName}- <img src='{Employee.ThumbUri}' />{Employee.NickName}{EndBand}";

            scope.currentAptServiceAddressText = 'Service Address';
            scope.currentAptServiceAddressValue = '{ServiceAddress}';

            scope.currentAptServiceStartTimeText = 'Service Start Time';
            scope.currentAptServiceStartTimeValue = '{ServiceStartTime}';

            scope.currentAptEventText = 'Event Name';
            scope.currentAptEventValue = '{Event.DisplayName}';

            scope.currentAptEventDescText = 'Event Description';
            scope.currentAptEventDescValue = '{Event.Desc}';

            scope.currentAptConfirmText = 'Confirmation'
            scope.currentAptConfirmValue = "<a href='{ConfirmUrl}'>Click here</a>"

            scope.currentAptRescheduleText = 'Reschedule'
            scope.currentAptRescheduleValue = "<a href='{RescheduleUrl}'>Click here</a>"

            scope.currentAptCancelText = 'Cancel'
            scope.currentAptCancelValue = "<a href='{CancellationUrl}'>Click here</a>"

            scope.currentAptMultiClientsBookedText = 'Multiple clients booked';
            scope.currentAptMultiClientsBookedValue = '{Appointment.MultiClientsBooked}';

            scope.currentAptResourceNameText = 'Resource Name';
            scope.currentAptResourceNameValue = '{Resource.DisplayName}';

            scope.currentClientFirstNameText = 'First Name of Servicing Client'
            scope.currentClientFirstNameValue = '{ClientFirstName}'

            scope.currentClientLastNameText = 'Last Name of Servicing Client'
            scope.currentClientLastNameValue = '{ClientLastName}'

            scope.pendingOpeningExpireTimeText = 'Pending Appt - Opening Expires Time'
            scope.pendingOpeningExpireTimeValue = '{PendingOpeningExpireTime}'

            scope.pendingRemovedAppointmentDateText = 'Pending Appt Removed - Appt Date'
            scope.pendingRemovedAppointmentDateValue = '{PendingRemovedAppointmentDate}'

            scope.pendingRemovedAppointmentTimeText = 'Pending Appt Removed - Appt Time'
            scope.pendingRemovedAppointmentTimeValue = '{PendingRemovedAppointmentTime}'

            scope.currentAptClientServicePriceText = 'Client Service Price';
            scope.currentAptClientServicePriceValue = '{ClientServicePrice}';

            scope.currentAptClientServiceLengthText = 'Client Service Length';
            scope.currentAptClientServiceLengthValue = '{ClientServiceLength}';

            scope.currentAptAddOnServiceDisplayNameText = 'Add On Service Display Name';
            scope.currentAptAddOnServiceDisplayNameValue = '{AddOnServiceDisplayName}';

            scope.currentAptNote = scope.currentAptNoteText;
            scope.currentAptShortDate = scope.currentAptShortDateText;
            scope.currentAptLongDate = scope.currentAptLongDateText;
            scope.currentAptStartTime = scope.currentAptStartTimeText;
            scope.currentAptFirstServiceDisplayName = scope.currentAptFirstServiceDisplayNameText;
            scope.currentAptAllServiceDisplayName = scope.currentAptAllServiceDisplayNameText;
            scope.currentAptAllServicesWithEmpName = scope.currentAptAllServicesWithEmpNameText;
            scope.currentAptServiceAddress = scope.currentAptServiceAddressText;
            scope.currentAptServiceStartTime = scope.currentAptServiceStartTimeText;
            scope.currentAptEvent = scope.currentAptEventText;
            scope.currentAptEventDesc = scope.currentAptEventDescText;
            scope.currentAptConfirm = scope.currentAptConfirmText;
            scope.currentAptReschedule = scope.currentAptRescheduleText;
            scope.currentAptCancel = scope.currentAptCancelText;
            scope.currentAptMultiClientsBooked = scope.currentAptMultiClientsBookedText;
            scope.currentAptResourceName = scope.currentAptResourceNameText;
            scope.currentClientFirstName = scope.currentClientFirstNameText;
            scope.currentClientLastName = scope.currentClientLastNameText;
            scope.pendingOpeningExpireTime = scope.pendingOpeningExpireTimeText;
            scope.pendingRemovedAppointmentDate = scope.pendingRemovedAppointmentDateText;
            scope.pendingRemovedAppointmentTime = scope.pendingRemovedAppointmentTimeText;
            scope.currentAptClientServicePrice = scope.currentAptClientServicePriceText;
            scope.currentAptClientServiceLength = scope.currentAptClientServiceLengthText;
            scope.currentAptAddOnServiceDisplayName = scope.currentAptAddOnServiceDisplayNameText;

            // Docs and forms
            scope.docsAndFormsUrlText = 'Docs and Form URL (Email)';
            scope.docsAndFormsUrlValue = "<a href='{DocsAndFormsUrl}'>Click here</a>";
            scope.docsAndFormsShortUrlText = 'Docs and Form URL (SMS)';
            scope.docsAndFormsShortUrlValue = '{DocsAndFormsShortUrl}';

            scope.docsAndFormsUrl = scope.docsAndFormsUrlText;
            scope.docsAndFormsShortUrl = scope.docsAndFormsShortUrlText;

            // Membership forms
            scope.membershipTransactionShortDateText = 'Transaction Short Date';
            scope.membershipTransactionShortDateValue = '{TransactionShortDate}';
            scope.membershipFormUrlText = 'Membership Form URL (Email)';
            scope.membershipFormUrlValue = "<a href='{MembershipFormsUrl}'>Click here</a>";
            scope.membershipFormShortUrlText = 'Membership Form URL (SMS)';
            scope.membershipFormShortUrlValue = '{MembershipFormsShortUrl}';

            scope.membershipTransactionShortDate = scope.membershipTransactionShortDateText;
            scope.membershipFormShortUrl = scope.membershipFormShortUrlText;
            scope.membershipFormUrl = scope.membershipFormUrlText;

            // Self-Pay
            scope.selfPayShortUrlText = 'Self Pay Link - SMS';
            scope.selfPayShortUrlValue = '{SelfPayShortUrl}'

            scope.selfPayShortUrl = scope.selfPayShortUrlText;


            scope.defaultDisplay = function (modelName: any, modelValue: any) {
                scope[modelName] = scope[modelValue];
            }
            scope.selectPlaceholder = function (modelName: any, $event, modelValue: any) {
                scope[modelName] = scope[modelValue];
                $event.target.select();
            }

            if (!scope.isSingleLocation) {
                scope.isSingleLocation = false;
            }

            this.$http({ url: "api/Settings/Cultural", method: "GET", data: null})
                .then((response: any) => {
                    if (response
                        && response.data
                        && (response.data.countryEnum == Meevo.Model.CountryEnum.Australia
                            || response.data.countryEnum == Meevo.Model.CountryEnum.NewZealand)) {

                        scope.busCityText = 'Suburb';
                        scope.busCityValue = '{BusinessInfo.Address.Suburb}';

                        scope.busZipCodeText = 'PostCode';
                        scope.busZipCodeValue = '{BusinessInfo.Address.PostCode}';

                    }
                });


            scope.executeCallbackFunction = function (modelName: any, $event, modelValue: any) {
                if (scope.callbackFunction) {
                    scope.callbackFunction(scope[modelValue], scope.context);
                }
            }

            scope.getSocialMediaLinkTag = function(order) {
                return scope["socialMediaLink_" + order + "_tag"];
            }

            this.$http({
                url: "/api/CustomData/Control/List/",
                method: "POST",
                headers: { "Content-Type": "application/json;charset=UTF-8" },
                data: {

                    "itemsPerPage": 100,
                    "pageNumber": 0,
                    "sortBy": "ControlName",
                    "sortDirection": 0,
                    "criteria": {
                        "appAreaEnum": null,
                        "controlTypeEnum": null,
                        "objectStateEnum": Meevo.Model.ObjectStateEnum.Active,
                        "shortcut": null,
                        "isIncludedInEmailNotification": true
                    }
                }
            }).then(response => {
                scope.UserDefinedTags = response.data;
                var groupedValues;
                scope.finalValue = _.groupBy(scope.UserDefinedTags, 'appAreaEnum');

                for (var appAreaEnum in scope.appEnums) {
                    if (scope.appEnums.hasOwnProperty(appAreaEnum) && /^\d+$/.test(appAreaEnum)) {

                        groupedValues = scope.finalValue[appAreaEnum];
                        if (appAreaEnum == "2229" /*Booking*/ && groupedValues) {
                            for (var i = 0; i < groupedValues.length; i++) {
                                scope[groupedValues[i].shortcut] = '{' + groupedValues[i].shortcut + '}';
                            }
                        }
                    }
                }
            });

            scope.getUserDefinedTag = function (userDefinedTagName: any) {
                return scope[userDefinedTagName] ? scope[userDefinedTagName] : null;
            }

            scope.changeDisplayedValue = function (model: any, value: any, $event) {
                model.displayedValue = '{' + value + '}';
                $event.target.select();
            }

            scope.changeDisplayedValueDefault = function (model: any, value: any) {
                model.displayedValue = value;
            }

            scope.enumText = function (enumValue) {
                return Meevo.Model.AppAreaEnum[enumValue];
            }
            input.on("keydown", (event: JQueryEventObject) => {
                // prevent from writing anything
                if ((event.shiftKey || (event.keyCode >= 48 || event.keyCode <= 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
                    event.preventDefault();
                }
                return true;
            });

            input.bind("cut copy paste", function (e) {
                e.preventDefault();
            });


            this.$http.get('api/Settings/SocialMediaLinks', null)
                .then((response: any) => {
                    var settings = response.data;
                    var normalizedSettings: any[] = [{ name: 'All Social Media Links (Email)', order: 0, tag: '{AllSocialMediaLinks}', displayName: 'All Social Media Links (Email)' }];
                    scope["socialMediaLink_0"] = normalizedSettings[0].name;
                    scope["socialMediaLink_0_tag"] = normalizedSettings[0].tag;
                    for (var i = 1; i <= settings.socialMediaCount; i++) {
                        if (settings["socialMediaIsActive_" + i]) {
                            let item = {
                                name: settings["socialMediaName_" + i] + " (Email)",
                                displayName: settings["socialMediaName_" + i] + " (Email)",
                                order: settings["socialMediaOrder_" + i],
                                tag: settings["socialMediaTag_" + i]
                            };
                            normalizedSettings[normalizedSettings.length] = item;
                            scope["socialMediaLink_" + item.order] = item.name;
                            scope["socialMediaLink_" + item.order + "_tag"] = item.tag;
                        }
                    }
                    scope.socialMediaSettings = normalizedSettings.sort((a, b) => { return (a.order - b.order); });
                });
        }
        constructor(private $http: angular.IHttpService) {

        }
        static factory(): angular.IDirectiveFactory {
            let directive = ($http: angular.IHttpService) => {
                return new MeevoNotificationTag($http);
            };
            directive.$inject = ["$http"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoNotificationTag", MeevoNotificationTag.factory());
}